<!-- 検索フォーム -->
<div class="GenerateSearch" [ngClass]="{ 'no-scroll': isM701 }">
  <form [formGroup]="generateSearchForm" autocomplete="off" (ngSubmit)="onSubmit()">
    <ng-container *ngIf="!isM701">
      <!-- 検索情報出力領域 -->
      <ng-container *ngFor="let generateSearch of generateSearchList">
        <!-- 検索項目タイプを判定 -->
        <!-- テキスト -->
        <div class="text" *ngIf="generateSearch.search_type == 'text'">
          <div class="textName">
            {{ generateSearch.column_name }}
          </div>
          <div class="textValue">
            <input title="フリーワード検索" [name]="generateSearch.column_id" type="text" size="30" [formControlName]="generateSearch.column_id"
              pInputText autocomplete="off" />
          </div>
        </div>

        <!-- 日付 -->
        <div class="date" *ngIf="generateSearch.search_type == 'date'">
          <div class="dateName" *ngIf="generateSearch.column_id == 'agenda_solution_start_date' 
          || generateSearch.column_id == 'agenda_solution_end_date'
          || generateSearch.column_id == 'agenda_need_start_date'
          || generateSearch.column_id == 'agenda_need_end_date'
          ;else dateNameOneLine">
            {{ generateSearch.column_name.split('（')[0]}}<br>
            {{ generateSearch.column_name.split('（')[1]}}
          </div>
          <ng-template #dateNameOneLine>
            <div class="dateName">
              {{ generateSearch.column_name }}
            </div>
          </ng-template>
          <div class="dateValue">
            <div class="p-d-flex p-ai-center">
              <div class="label">
                開始:
              </div>
              <div class="calendar">
                <p-calendar [name]="generateSearch.column_id + '_FROM'" [showIcon]="true" [readonlyInput]="true"
                  dateFormat="yy/mm/dd" dataType="string" appendTo="body"
                  [formControlName]="generateSearch.column_id + '_FROM'" translate></p-calendar>
              </div>
            </div>
            <br />
            <div class="verticalTilde">〜</div>
            <div class="p-d-flex p-ai-center">
              <div class="label">
                終了:
              </div>
              <div class="calendar">
                <p-calendar [name]="generateSearch.column_id + '_TO'" [showIcon]="true" [readonlyInput]="true"
                  dateFormat="yy/mm/dd" dataType="string" appendTo="body"
                  [formControlName]="generateSearch.column_id + '_TO'" translate></p-calendar>
              </div>
            </div>
          </div>
        </div>

        <!-- 数値 -->
        <div class="number" *ngIf="generateSearch.search_type == 'number'">
          <div class="numberName">{{ generateSearch.column_name }}</div>
          <div class="numberValue">
            開始:<input title="開始" [name]="generateSearch.column_id + '_FROM'" [formControlName]="generateSearch.column_id + '_FROM'"
              type="number" pInputText autocomplete="off" />
            <br />
            <div class="verticalTilde">〜</div>
            終了:<input title="終了" [name]="generateSearch.column_id + '_TO'" [formControlName]="generateSearch.column_id + '_TO'"
              type="number" pInputText autocomplete="off" />
          </div>
        </div>

        <!-- チェックボックス -->
        <div class="checkbox" *ngIf="generateSearch.search_type == 'checkbox'">
          <div class="checkboxName">
            {{ generateSearch.column_name }}
          </div>
          <div class="checkBoxValue">
            <ng-container *ngFor="let code_list of generateSearch.code_list_multi">
              <p class="p-field-checkbox">
                <p-checkbox [name]="generateSearch.column_id" [label]="code_list.name" [value]="code_list.value"
                  [formControl]="
                  generateSearchForm.controls[generateSearch.column_id]
                "></p-checkbox>
              </p>
            </ng-container>
          </div>
        </div>

        <!-- プルダウン -->
        <div class="pulldown" *ngIf="generateSearch.search_type == 'pulldown'">
          <ng-container
            *ngIf="generateSearch.column_id == 'member_class_id' || generateSearch.column_id == 'member_class_sub_id'; else elseTemplate">
            <ng-container *ngIf="generateSearch.column_id == 'member_class_id'">
              <div class="pulldownName">
                {{ generateSearch.column_name }}
              </div>
              <div class="pulldownValue">
                <p-multiSelect [options]="generateSearch.code_list_multi" optionLabel="name" optionValue="value"
                  (onChange)="onChangeClassId($event.value)"
                  [formControlName]="generateSearch.column_id"></p-multiSelect>
              </div>
            </ng-container>
            <ng-container *ngIf="generateSearch.column_id == 'member_class_sub_id'">
              <div class="pulldownName">
                {{ generateSearch.column_name }}
              </div>
              <div class="pulldownValue">
                <p-multiSelect [name]="generateSearch.column_id" [options]="organizationDetail" optionLabel="name"
                  optionValue="value" [formControlName]="generateSearch.column_id"></p-multiSelect>
              </div>
            </ng-container>
          </ng-container>

          <ng-template #elseTemplate>
            <div class="pulldownName">
              {{ generateSearch.column_name }}
            </div>
            <div class="pulldownValue">
              <p-multiSelect [name]="generateSearch.column_id" [options]="generateSearch.code_list_multi"
                optionLabel="name" optionValue="value" [formControlName]="generateSearch.column_id"></p-multiSelect>
            </div>
          </ng-template>
        </div>



        <!-- テキストエリア -->
        <div class="list" *ngIf="generateSearch.search_type == 'list'">
          <div class="listName">
            {{ generateSearch.column_name }}
          </div>
          <div class="listValue">
            <textarea [name]="generateSearch.column_id" rows="10" maxlength="1000"
              [formControlName]="generateSearch.column_id" pInputTextarea autocomplete="off"></textarea>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isM701">
      <div class="p-d-flex box-freeword">
        <input title="フリーワード検索" type="text" pInputText class="freeword-inputtext" [formControl]="generateSearchForm.controls.freeword" />
        <i class="pi pi-search search-icon"></i>
      </div>
      <p-accordion [multiple]="true">
        <ng-container *ngFor="let generateSearch of generateSearchList; index as i">
          <p-accordionTab [header]="generateSearch.column_name" [disabled]="isDisabledTab(generateSearch.column_id)"
            [(selected)]="listSelected[generateSearch.column_id]" (click)="onPanelOpen($event)">
            <div class="accrodion-form-list">
              <div class="btn-check">
                <span><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'checkAll',
                                  generateSearch.code_list_multi,
                                  generateSearch.column_id
                                )
                              ">すべて選択</a> </span>　|　
                <span class="p-ml-2"><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'removeAll',
                                  generateSearch.code_list_multi,
                                  generateSearch.column_id
                                )
                              ">解除</a></span>
              </div>
              <div *ngFor="let dicData of generateSearch.code_list_multi">
                <p-checkbox [label]="dicData.name" [value]="dicData.value"
                  [formControl]="generateSearchForm.controls[generateSearch.column_id]"></p-checkbox>
              </div>
            </div>
          </p-accordionTab>
        </ng-container>
      </p-accordion>
    </ng-container>
  </form>

  <!-- ボタンエリア -->
  <div class="buttonArea" *ngIf="!isM701">
    <input title="検索ボタン" pButton type="submit" value="検索" class="p-button-raised p-mr-2 button p-button-br-7" (click)="onSubmit()" />
    <input title="クリアボタン" pButton type="submit" value="クリア" class="p-button-raised p-mr-2 button p-button-br-7" (click)="reset()" />
  </div>
  <div class="buttonArea" *ngIf="isM701">
    <input title="検索ボタン" pButton type="submit" value="検索" class="p-button-raised p-mr-2 button p-button-br-7" (click)="onSubmit()" />
  </div>
</div>